export const ROUTES = {
  ANY: '*',
  MAIN: {
    ROOT: '/',
  },
  AUDIO: {
    ROOT: '/audio',
    EDIT: '/audio/:id',
    CREATE: '/audio/create',
    CREATE_WITH_TYPE: (trackType: string) =>
      `/audio/create?tracktype=${trackType}`,
  },
  COLLECTIONS: {
    ROOT: '/collections',
    ALBUMS: '/collections#album',
    ALBUM_COLLECTIONS: '/collections#albumcollection',
    CREATE_ALBUM: '/collections/albums/create',
    EDIT_ALBUM: '/collections/albums/:id',
    CREATE_ALBUM_COLLECTION: '/collections/album_collections/create',
    EDIT_ALBUM_COLLECTION: '/collections/album_collections/:id',
  },
  AUTHORS: {
    ROOT: '/authors',
    EDIT: '/authors/:id',
  },
  JINGLES: {
    ROOT: '/jingles',
    COLLECTIONS: '/jingles#collection',
    CREATE_COLLECTION: '/jingles/create_collection',
    EDIT_COLLECTION: '/jingles/collections/:id',
  },
  TAGS: {
    ROOT: '/tags',
  },
  SETTINGS: {
    MY_WAVE: '/settings/my-wave',
    NOTIFICATIONS: '/settings/notifications',
    CREATE_NOTIFICATION: '/settings/notifications/create',
    EDIT_NOTIFICATION: '/settings/notifications/:id',
    GREETINGS: '/settings/greetings',
    POLICY: '/settings/policy',
  },
  STATS: {
    ROOT: '/stats',
  },
  DONATIONS: {
    ROOT: '/acquiring',
    USER: '/acquiring/user/:id',
  },
  FEEDBACK: {
    ROOT: '/feedback',
    CHAT: '/feedback/:id?',
  },
  ADMINS: {
    ROOT: '/admins',
  },
} as const
